import React from "react";

import { TableRow, TableCell } from '@mui/material';
import PropTypes from 'prop-types'

const EmptyRows = ({
    height = 0,
    emptyRows = 0,
    cols = 0
}) => {

    return (
        <TableRow style={{ height: height * emptyRows }}>
            <TableCell colSpan={cols} />
        </TableRow>
    )
}

EmptyRows.propTypes = {
    /** Row height */
    height: PropTypes.number,
    /** Number of blank lines */
    emptyRows: PropTypes.number,
    /** Number of columns */
    cols: PropTypes.number,
}


export default EmptyRows